import {Button, Divider, Stack} from '@mui/material';
import React from 'react';

import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';

import {BookingNotFoundDialog} from '../BookingNotFoundDialog';
import {BookingNotFoundListCardProps} from './types';
import {useNotFound} from 'presentation/pages/private/hooks/useNotFound';

const {orientationCard} = translations['pt-br'].privateFlow.profile.locationSelection;

export function BookingNotFoundListCard({
	customOrientationText,
	variant,
	flowType,
	children,
	openModalDataTagId,
	modalFirstActionDataTagId,
	modalSecondActionDataTagId,
	modalHeaderModalDataTagId,
	modalCloseModalDataTagId,
}: BookingNotFoundListCardProps) {
	const {isMobile} = useMediaQueries();
	const {handleCallChatRoom, handleGuideNav, notFoundModalIsOpen, setNotFoundModalIsOpen} =
		useNotFound();

	function handleOpenModal() {
		setNotFoundModalIsOpen(true);
	}

	return (
		<Stack gap={2}>
			<Divider />
			<Stack
				alignItems={'end'}
				direction={children ? 'row' : 'column'}
				justifyContent={'space-between'}>
				<Button
					variant="outlined"
					fullWidth={isMobile}
					size="large"
					onClick={handleOpenModal}
					data-tag-id={openModalDataTagId}>
					{customOrientationText ?? orientationCard}
				</Button>
				{children}
			</Stack>
			<BookingNotFoundDialog
				headerModalDataTagId={modalHeaderModalDataTagId}
				closeModalDataTagId={modalCloseModalDataTagId}
				firstActionDataTagId={modalFirstActionDataTagId}
				secondActionDataTagId={modalSecondActionDataTagId}
				flowType={flowType}
				variant={variant}
				handleCallChatRoom={() => handleCallChatRoom(flowType)}
				handleGuideNav={() => handleGuideNav(flowType)}
				open={notFoundModalIsOpen}
				setOpen={setNotFoundModalIsOpen}
			/>
		</Stack>
	);
}
